module.exports = __webpack_public_path__ + "assets/60cc7c98d08ec03bf61764c8f555a50c.mp3";